// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_1000":"col_1000-1N3lfWcG","space31":"space31-3lYBgES2","zkcp_title":"zkcp_title-x_1L8S6x"};